export const prices = [
  {
    _id: 0,
    name: "Any",
    array: [],
  },
  {
    _id: 2,
    name: "₹0 to ₹100   ",
    array: [0, 100],
  },
  {
    _id: 3,
    name: "₹100 to ₹500   ",
    array: [100, 500],
  },
  {
    _id: 4,
    name: "₹500 to ₹1000   ",
    array: [500, 1000],
  },
  {
    _id: 5,
    name: "₹1000+ (MORE THAN ₹1000)  ",
    array: [1000, 10000],
  },
];
